import React from "react"
//import components
import Breadcrumbs from "components/Common/Breadcrumb"
import { useTranslation } from "react-i18next"

import KickersTable from "./KickersTable"

export default function KickersList() {
  const { t } = useTranslation()

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("pages.Kickers")} />
        <KickersTable />
      </div>
    </div>
  )
}
